import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Menu } from "antd";
import {
  UserOutlined,
  DashboardOutlined,
  UsergroupAddOutlined,
  HomeOutlined,
  FileSearchOutlined,
  InboxOutlined,
  SolutionOutlined,
  SettingOutlined,
  FieldTimeOutlined,
  LogoutOutlined,
  IdcardOutlined,
} from "@ant-design/icons";

import { setUserAccount } from "../../redux/reducers/userAccountSlice";

import "./navigation.styles.css";

const Navigation = ({ userName }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentMenuItem = useSelector((state) => state.navigation.menu);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const items = [
    {
      label: "Dashboard",
      key: "dashboard",
      icon: <DashboardOutlined />,
    },
    {
      label: "Reporte de Visitas",
      key: "visitsReport",
      icon: <FileSearchOutlined />,
    },
    {
      label: "Invitaciones",
      key: "invitationsReport",
      icon: <InboxOutlined />,
    },
    {
      label: "Invitados",
      key: "guestReport",
      icon: <SolutionOutlined />,
    },
    {
      label: "Usuarios",
      key: "userMaintenance",
      icon: <UsergroupAddOutlined />,
    },
    {
      label: "Residentes",
      key: "residentMaintenance",
      icon: <UsergroupAddOutlined />,
    },
    {
      label: "Residencias",
      key: "locationMaintenance",
      icon: <HomeOutlined />,
    },
    {
      label: "Pre-autorizados",
      key: "preAuthorizedMaintenance",
      icon: <IdcardOutlined />,
    },
    {
      label: "Horarios",
      key: "schedulesMaintenance",
      icon: <FieldTimeOutlined />,
      children: [
        {
          label: "Rangos de horario",
          key: "schedulesMaintenance/schedules",
        },
        {
          label: "Grupos de horario",
          key: "schedulesMaintenance/schedulesGroup",
        },
      ],
    },
    {
      label: "Configuración",
      key: "settings",
      icon: <SettingOutlined />,
    },
    {
      label: userName,
      key: "userMenu",
      icon: <UserOutlined />,
      children: [
        {
          label: "Cerrar sesión",
          key: "logout",
          icon: <LogoutOutlined />,
        },
      ],
    },
  ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    dispatch(setUserAccount(null));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onClickMenu = (e) => {
    switch (e.key) {
      case "userMaintenance":
        navigate("/user-maintenance");
        break;
      case "residentMaintenance":
        navigate("/resident-maintenance");
        break;
      case "locationMaintenance":
        navigate("/location-maintenance");
        break;
      case "preAuthorizedMaintenance":
        navigate("/pre-authorized-maintenance");
        break;
      case "visitsReport":
        navigate("/visits-report");
        break;
      case "invitationsReport":
        navigate("/invitations-report");
        break;
      case "guestReport":
        navigate("/guest-report");
        break;
      case "schedulesMaintenance/schedules":
        navigate("/schedules-maintenance");
        break;
      case "schedulesMaintenance/schedulesGroup":
        navigate("/schedules-group-maintenance");
        break;
      case "settings":
        navigate("/settings");
        break;
      case "logout":
        showModal();
        break;
      default:
        navigate("/");
        break;
    }
  };

  return (
    <div className="navigation-container">
      <Menu
        selectedKeys={[currentMenuItem]}
        mode="horizontal"
        items={items}
        onClick={onClickMenu}
      />
      <Modal
        title="Cerrar Sesión"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Sí"
        cancelText="Cancelar"
      >
        ¿Confirmar cierre de sesión?
      </Modal>
      <Outlet />
    </div>
  );
};

export default Navigation;
